<div class="community-section">
  <div class="left">
    <div class="text">
      <h3>Join the community of smart business decision makers</h3>
    </div>
    <div class="c-button">
      <button class="btn-hst" (click)="paymentGateway()">
        Create merchant account
      </button>
      <!-- <button class="btn-hst-two" (click)="paymentGateway()">
        Create e-commerce account
      </button> -->
    </div>
  </div>
</div>
